import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import { debounceTime, filter } from 'rxjs/operators';

@Component({
  selector: 'nc-infinite-scroll',
  templateUrl: './infinite-scroll.component.html',
  styleUrls: ['./infinite-scroll.component.less']
})
export class InfiniteScrollComponent implements AfterViewInit {
  @ViewChild('scrollContainer') private scrollContainer!: ElementRef;

  /** 滚动到底部时回调 */
  @Output() ncReachedBottom = new EventEmitter();
  /** 是否禁用检测 */
  private _disableDetection: boolean = false;
  @Input() set ncDisableDetection(value: boolean | string) {
    this._disableDetection = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  get ncDisableDetection(): boolean {
    return this._disableDetection;
  }
  /** 触发加载的距离阈值，单位为px */
  @Input() ncDistance: number = 0;
  /** 防抖延迟（单位ms），默认用户停止滚动触底200ms后执行方法 */
  @Input() ncDelay: number = 200;

  private scrollSubject = new Subject<void>();
  private isNearBottom = false;

  constructor() { }

  ngAfterViewInit(): void {
    this.initScrollListener();
  }

  private initScrollListener(): void {
    const scrollElement = this.scrollContainer.nativeElement;

    fromEvent(scrollElement, 'scroll').subscribe(() => {
      this.handleScroll(scrollElement);
    });

    this.scrollSubject.pipe(
      debounceTime(this.ncDelay),
      filter(() => !this.ncDisableDetection)
    ).subscribe(() => {
      if (this.isNearBottom) {
        this.ncReachedBottom.emit();
      }
    });
  }

  private handleScroll(element: HTMLElement): void {
    const { scrollTop, clientHeight, scrollHeight } = element;
    this.isNearBottom = scrollTop + clientHeight >= scrollHeight - this.ncDistance;
    if (this.isNearBottom) {
      this.scrollSubject.next();
    }
  }
}
